<template>
  <div v-if="isEmptyData" class="table-no-data"><p class="text-small">No data</p></div>
</template>
<script>
  import Vue from "vue";

  export default Vue.extend({
    props: {
      isEmptyData: {
        type: Boolean,
        required: true
      }
    }
  })
</script>